export const AUTHENTICATION_ACTION_TYPES = {
    SET_CURRENT_USER: 'authentication/SET_CURRENT_USER',
};